class ScxStickyBuy extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.addEventListener("DOMContentLoaded", () => {
      const targetDiv = document.querySelector("#desktop-buy-button");
      const mobileDiv = document.querySelector("#mobile-buy-btns");

      function handleVisibilityChange(entry) {
        if (entry.isIntersecting) {
          mobileDiv.setAttribute("data-show", "false");
        } else {
          mobileDiv.setAttribute("data-show", "true");
        }
      }

      // Initialize Intersection Observer
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => handleVisibilityChange(entry));
        },
        {
          root: null, // Viewport as the root
          threshold: 0.5, // Trigger when 50% of the element is visible
        }
      );

      // Observe the target div
      if (targetDiv) {
        observer.observe(targetDiv);
      }
    });
  }
}

customElements.define("scx-sticky-buy", ScxStickyBuy);
